import React, { Component } from "react";
import { get as _get } from "lodash";

export default class CrewSheetDrivingDirections extends Component {
  getMilesFromMeters = (meters) => {
    return Math.round((meters / 1609.344) * 100) / 100;
  };

  //durantion comes in seconds
  makeDurationReadable = (duration) => {
    if (!duration) return "";

    const total_minutes = Math.round(duration / 60);
    const hours = Math.floor(total_minutes / 60);
    const minutes = total_minutes % 60;
    let result = "";

    if (hours) {
      result += hours + "h ";
    }

    result += minutes + "min";
    return result;
  };

  buildListDirections() {
    //remember that the number of legs is the same as the number of canvassers, and canvassers have been presorted to dropoff order.
    let { crew } = this.props;

    let legElems = [];

    _get(crew, "directions.legs", [])
      // .reverse()
      .map((leg, index, array) => {
        let count = leg.steps.length;
        let stepElems = [];

        let canvasser = _get(crew, `canvassers[${index}]`, {});

        leg.steps.forEach((step, i) => {
          let initials =
            _get(canvasser, "firstname", " ")[0] +
            _get(canvasser, "lastname", " ")[0];
          let stepCount = `${i + 1}/${count}`;
          stepElems.push(
            <span>
              <p className="steps">
                <b>{_get(step, "maneuver.instruction", "")}</b>
              </p>
              {this.makeDurationReadable(step.duration)} (
              {this.getMilesFromMeters(step.distance)} miles) : {stepCount}
            </span>
          );
        });

        legElems.push(
          <div key={leg.distance.text} className="column-list">
            {crew.route_to_all_sites ? (
              <>
                <h5>
                  To: <b>{_get(crew, `canvassers[0].sites[${index}].name`)}</b>
                </h5>
                <p>Summary: {leg.summary}</p>
              </>
            ) : (
              <>
                <h5 className="leg-title">
                  {canvasser.firstname} {canvasser.lastname}
                </h5>
                <div>
                  To:{" "}
                  <b>
                    {_get(canvasser, "dropoff.name", "") ||
                      _get(canvasser, "dropoff.address", "") ||
                      _get(canvasser, "dropoff.waypoint.name", "") ||
                      _get(canvasser, "dropoff.latitude", "") +
                        ", " +
                        _get(canvasser, "dropoff.longitude", "")}
                  </b>
                </div>
                <p>Summary: {leg.summary}</p>
              </>
            )}
            Summary: {this.makeDurationReadable(leg.duration)} (
            {this.getMilesFromMeters(leg.distance)} miles)
            <br />
            {stepElems}
          </div>
        );
      });
    return legElems;
  }

  render() {
    return <div className="wrap-list">{this.buildListDirections()}</div>;
  }
}
